<template>
  <div class="form-group no-margin row">
    <div class="col-auto" v-show="type != 'no'">
      <label class="col-form-label">{{ label }}</label>
    </div>
    <div class="col-auto" v-show="type != 'no'" >
      <select class="custom-select custom-select-sm" v-model="data.params.schType" name="srchType" v-show="type != 'select_no'">
        <option v-if="includeAll" value="" selected="selected">전체</option>
        <option v-for="(option, index) in data.schOptions" :value="option.value" :key="index">
          {{ option.text }}
        </option>
      </select>
    </div>
    <div class="col-auto">
      <input type="text" v-model="data.params.schText" @keyup.enter="search()" class="form-control mb-2"
             style="width:200px">
    </div>
    <div class="col-auto">
      <b-button-group>
        <button @click="search()" class="btn btn-primary mb-2"><i class="fa fa-search"></i>Search</button>
        <button @click="reset()" class="btn btn-secondary  mb-2">Clear</button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import {reactive, ref, computed, watch, onMounted, onUnmounted} from '@vue/composition-api'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment';

export default {
  props: {
    data: {
      schText : "",
      schType: "",
    },
    label: "",
    type : "",
    resetable : "", // 'yes' or 'no' reset에서 emit 할지 여부.
    includeAll : {
      default:true
    }
  },
  components: {Datepicker},
  setup(props, context) {
    const data = props.data;

    return {
      ...actions(props, props.data, context)
    }
  }
}

function actions(props, data, context) {
  function search() {
    data.params.page = 1; //검색 후 1페이지로 이동
    context.emit('search', data.params)
  }

  function reset() {
    data.params.schText = '';
   // context.emit('reset')
   if (props.resetable == 'yes') {
    data.params.schType = '';
    context.emit('reset')
   }
  }

  return {search, reset}
}
</script>
